/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { cluster_id } from '../models/cluster_id';
import type { ClusterForList } from '../models/ClusterForList';
import type { ClusterForNew } from '../models/ClusterForNew';
import type { ClusterForUpdate } from '../models/ClusterForUpdate';
import type { ClusterListParams } from '../models/ClusterListParams';
import type { ClusterObservabilityHistorySample } from '../models/ClusterObservabilityHistorySample';
import type { ClusterObservabilityLogEntry } from '../models/ClusterObservabilityLogEntry';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ClustersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Create a new Cluster
     * Creates a new Cluster. (Access: admin)
     * @returns any Unexpected error
     * @returns ClusterForUpdate Cluster created. The URI of the new resource is included in the Location header of the response.
     * @throws ApiError
     */
    public createCluster({
        requestBody,
    }: {
        /**
         * Cluster's information
         */
        requestBody: ClusterForNew,
    }): CancelablePromise<{
        code: number;
        message: string;
    } | ClusterForUpdate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get a list of Clusters
     * Get a list of Clusters. (Access: admin)
     * @returns any Clusters list
     * @throws ApiError
     */
    public getClusters({
        requestBody,
    }: {
        /**
         * Cluster's information
         */
        requestBody: ClusterListParams,
    }): CancelablePromise<{
        clusters: Array<ClusterForList>;
        total_clusters: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a Cluster
     * Returns a Cluster based on a single ID (Access: admin)
     * @returns ClusterForList Cluster's information
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getClusterById({
        id,
    }: {
        /**
         * ID of the Cluster to fetch
         */
        id: cluster_id,
    }): CancelablePromise<ClusterForList | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update a Cluster
     * Update a Cluster. (Access: admin)
     * @returns ClusterForUpdate Cluster updated.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateCluster({
        id,
        requestBody,
    }: {
        /**
         * ID of the CLuster to update
         */
        id: cluster_id,
        /**
         * Cluster's information
         */
        requestBody: ClusterForUpdate,
    }): CancelablePromise<ClusterForUpdate | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clusters/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Conflict`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Delete a cluster
     * Deletes a single CLuster based on the ID supplied. (Access: admin)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteClusterById({
        id,
    }: {
        /**
         * ID of the Cluster to delete
         */
        id: cluster_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get cluster observability history
     * @returns any Cluster observability samples
     * @throws ApiError
     */
    public getClusterObservabilityHistory({
        id,
        from,
        to,
        bucketSeconds = 60,
    }: {
        id: cluster_id,
        from?: string,
        to?: string,
        bucketSeconds?: number,
    }): CancelablePromise<{
        samples: Array<ClusterObservabilityHistorySample>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{id}/observability/history',
            path: {
                'id': id,
            },
            query: {
                'from': from,
                'to': to,
                'bucket_seconds': bucketSeconds,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get recent redacted cluster-manager logs
     * @returns any Recent log entries
     * @throws ApiError
     */
    public getClusterObservabilityLogs({
        id,
        afterId,
        limit,
    }: {
        id: cluster_id,
        afterId?: number,
        limit?: number,
    }): CancelablePromise<{
        entries: Array<ClusterObservabilityLogEntry>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{id}/observability/logs',
            path: {
                'id': id,
            },
            query: {
                'after_id': afterId,
                'limit': limit,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
